/* eslint-disable @typescript-eslint/no-unused-vars */

const REPO_NAME = 'web-react';

const logFactory = (_suffix: string) => (..._noop: any[]) => {};

export { logFactory };
